import { Link } from 'react-router-dom'

const S = ({ n, title, children }: { n: string; title: string; children: React.ReactNode }) => (
  <div style={{ marginBottom: 32 }}>
    <h2 style={{ fontFamily: 'Syne', fontWeight: 800, fontSize: '.92rem', color: 'var(--bill)', marginBottom: 10, paddingBottom: 8, borderBottom: '1px solid var(--edge)' }}>
      {n}. {title}
    </h2>
    <div style={{ fontFamily: 'Space Grotesk', fontSize: '.82rem', color: 'var(--muted)', lineHeight: 1.85 }}>
      {children}
    </div>
  </div>
)

const P = ({ children, style }: { children: React.ReactNode; style?: React.CSSProperties }) =>
  <p style={{ marginBottom: 10, ...style }}>{children}</p>

export default function Terms() {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--ink)', paddingBottom: 80 }}>
      <div style={{ borderBottom: '1px solid var(--edge)', padding: '14px 24px', display: 'flex', alignItems: 'center', gap: 16 }}>
        <Link to="/" style={{ fontFamily: 'Syne', fontWeight: 900, fontSize: '1rem', color: 'var(--cash)', textDecoration: 'none', letterSpacing: '-0.03em' }}>Polywally</Link>
        <span style={{ color: 'var(--edge)' }}>·</span>
        <span style={{ fontFamily: 'Syne Mono', fontSize: '.6rem', color: 'var(--muted)', letterSpacing: '.1em', textTransform: 'uppercase' }}>Terms of Service</span>
      </div>

      <div style={{ maxWidth: 680, margin: '0 auto', padding: '52px 24px 0' }}>
        <div style={{ marginBottom: 44 }}>
          <h1 style={{ fontFamily: 'Syne', fontWeight: 900, fontSize: '2rem', color: 'var(--bill)', letterSpacing: '-0.03em', lineHeight: 1.1, marginBottom: 12 }}>Terms of Service</h1>
          <div style={{ fontFamily: 'Syne Mono', fontSize: '.6rem', color: 'var(--muted)', opacity: .6 }}>
            Effective: February 2026 · <span style={{ color: 'var(--cash)' }}>support@polywally.com</span>
          </div>
        </div>

        <S n="1" title="Agreement">
          <P>By using Polywally, you agree to these Terms of Service and our Privacy Policy. If you do not agree, please do not use the platform.</P>
        </S>

        <S n="2" title="Who Can Use Polywally">
          <P>You must be at least 13 years old and located in a jurisdiction where use of this platform is lawful. By creating an account, you confirm you meet these requirements and will use Polywally in accordance with these Terms.</P>
        </S>

        <S n="3" title="What Polywally Is">
          <P>Polywally is an educational platform offering AI-powered chart analysis, options analysis, paper trading simulation, and related trading tools. All analysis is generated for learning purposes only. Polywally does not provide financial advice, execute real trades, or hold any of your funds.</P>
        </S>

        <S n="4" title="Subscriptions and Payments">
          <P>Paid plans are billed through Stripe on a recurring basis. You may cancel at any time through your account settings to stop future charges. Because our services consume AI and infrastructure resources at the point of use, all payments are non-refundable once a billing period has begun. For billing questions, reach us at <span style={{ color: 'var(--cash)' }}>support@polywally.com</span>.</P>
        </S>

        <S n="5" title="Paper Trading">
          <P>The paper trading feature connects to Alpaca Securities' paper trading environment using API keys you create and provide. All activity is simulated with virtual funds. No real money changes hands through Polywally. You are responsible for creating your own Alpaca account and complying with their terms of service. Polywally is not affiliated with Alpaca and is not responsible for their platform or data.</P>
        </S>

        <S n="6" title="Acceptable Use">
          <P>You may use Polywally solely for its intended educational purpose. The following are prohibited: accessing or attempting to access the platform through unauthorized means; reverse-engineering, decompiling, or scraping any part of the platform or its API; using automated tools to query, extract, or replicate platform data; circumventing subscription tiers or access controls; reselling, sublicensing, or redistributing platform output for commercial purposes; and any use that violates applicable law or regulation. We reserve the right to limit, suspend, or terminate access at any time, with or without notice, if we believe these Terms have been violated.</P>
        </S>

        <S n="7" title="Intellectual Property">
          <P>All content on Polywally, including design, branding, code, and copy, is owned by Polywally and protected by applicable intellectual property laws. You may not reproduce, redistribute, or commercially exploit any part of the platform without written permission.</P>
        </S>

        <S n="8" title="No Financial Advice">
          <P>Nothing on Polywally constitutes financial, investment, or legal advice. You are solely responsible for any decisions you make based on content from this platform. Polywally is not liable for any losses arising from use of its analysis or tools. Always consult a licensed financial advisor before making investment decisions.</P>
        </S>

        <S n="9" title="Limitation of Liability">
          <P>To the fullest extent permitted by applicable law, Polywally disclaims all warranties and shall not be liable for any indirect, incidental, or consequential damages, including data loss, financial loss, or business interruption, arising from your use of the platform. Our total liability to you shall not exceed the amount you paid us in the twelve months prior to any claim.</P>
        </S>

        <S n="10" title="Changes to These Terms">
          <P>We may update these Terms from time to time. Changes will be posted on this page with a revised effective date. Your continued use of Polywally after an update constitutes acceptance of the revised Terms.</P>
        </S>

        <S n="11" title="Governing Law">
          <P>These Terms are governed by the laws of the State of California, without regard to its conflict of law provisions.</P>
        </S>

        <S n="12" title="Contact">
          <P>Questions about these Terms can be directed to <span style={{ color: 'var(--cash)' }}>support@polywally.com</span>.</P>
        </S>

        <div style={{ marginTop: 48, paddingTop: 24, borderTop: '1px solid var(--edge)', display: 'flex', gap: 20, flexWrap: 'wrap', fontFamily: 'Syne Mono', fontSize: '.6rem' }}>
          <Link to="/" style={{ color: 'var(--cash)', textDecoration: 'none' }}>Back to Polywally</Link>
          <Link to="/privacy" style={{ color: 'var(--muted)', textDecoration: 'none' }}>Privacy Policy</Link>
          <Link to="/disclaimer" style={{ color: 'var(--muted)', textDecoration: 'none' }}>Disclaimer</Link>
        </div>
      </div>
    </div>
  )
}
